import React, { createContext } from 'react';

export const ServicesContext = createContext();